import React, { useState, useEffect } from "react";
import { nomService } from '../../services/api/nom.service';
import { PatientSubscriptions } from "./patientSubscriptions";
import { PatientConsultations } from "./patientConsultations";
import { PatientPreauthorizations } from "./patientPreauthorizations";
import { PatientAddSpecialConsultation } from "./patientAddSpecialConsultation"
import { PatientMMTemporaryAlocation } from "./patientMMTemporaryAlocation"
import { PatientMMRecords } from "./patientMMRecords"
import { PatientMMPreauthorizations } from "./patientMMPreauthorizations"
import { alertService } from "../../services/helpers/alert.service";
import { useNavigate } from "react-router-dom";


export const PatientInfo = ({ cnp, activeComponent }) => {
    const [patientData, setPatientData] = useState({id : ""});
    const navigate = useNavigate();
    

    useEffect(() => {
        if (cnp) {
            nomService.getPatientbyCNP({ cnp: cnp })
                .then(response => {
                    if (response) {
                        setPatientData(response);
                    }
                    else {
                        setPatientData(null);


                        if (cnp && cnp.length == 13) {
                            nomService.isCNPAdded({ cnp: cnp }).then(response => {
                                if (response && response.id == 1) {
                                    alertService.error("Exista o cerere de adaugare a pacientului cu CNP-ul " + cnp + ". Asteptati procesarea cererii !")
                                    return
                                }
                                else {
                                    if ((activeComponent == "MMTemporaryAlocation" || activeComponent == "AddSpecialConsultation") && cnp && cnp.length == 13) {
                                        alertService.confirm("Cautare pacient", "Nu exista nici un pacient cu cnp sau codul de pacient: " + cnp + ". Doriti sa adaugati un pacient nou?",
                                            () => {
                                                navigate("/dashboard/adauga-pacient?cnp=" + cnp);
                                                return;
                                            },
                                            () => { });
                                    }
                                }
                            })
                        }



                    }
                });
        }
    }, [cnp, activeComponent]);
    

    return (
        <>
            {patientData && (<div data-name="detalii_pacient" className="detalii_pacient pt10">
                <p>Nume: <span data-name="nume"> {patientData.nume}</span> <span data-name="prenume">{patientData.prenume}</span></p>
                <p>CNP: <span data-name="cnp"> {patientData.cnp}</span></p>
                <p>Cod Pacient: <span data-name="cod_pacient"> {patientData.codPacient}</span></p>
            </div>)
            }
            <div data-name="rezultat" className="pt10">
                {patientData && activeComponent === "Subscriptions" && <PatientSubscriptions cnp={patientData.cnp} activeComponent={activeComponent} searchCode={ cnp } />}
                {patientData && activeComponent === "Consultations" && <PatientConsultations cnp={patientData.cnp} activeComponent={activeComponent} searchCode={cnp} />}
                {patientData && activeComponent === "Preauthorizations" && <PatientPreauthorizations cnp={patientData.cnp} activeComponent={activeComponent} searchCode={cnp} />}
                {patientData && activeComponent === "AddSpecialConsultation" && <PatientAddSpecialConsultation cnp={patientData.cnp} activeComponent={activeComponent} pacient={patientData.id} searchCode={cnp} />}
                {patientData && activeComponent === "MMRecords" && <PatientMMRecords cnp={patientData.cnp} activeComponent={activeComponent} searchCode={cnp} />}
                {activeComponent === "MMTemporaryAlocation" && <PatientMMTemporaryAlocation activeComponent={activeComponent} pacient={patientData?.id} cnp={patientData?.cnp} searchCode={cnp} />}
                {patientData && activeComponent === "MMPreauthorization" && <PatientMMPreauthorizations cnp={patientData.cnp} activeComponent={activeComponent} searchCode={cnp} />}
            </div>
        </>
    );
}